import React, { useState } from "react";
import { Icon } from "../Icon";
import { COMPANY } from "../data";
import { ABOUT, CAPABILITY_FLOW, CAPABILITY_NOTE, MESSAGES, POSITIONING } from "../content";
import { CtaBand, FlowLine, PageHero, SectionHead, useSeo } from "../ui";

/* 장비 사진 — 파일이 아직 없으면 사진 칸만 빠진다 */
function EquipPhoto({ src, alt }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return null;
  return (
    <div className="equip__photo">
      <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />
    </div>
  );
}

export default function About() {
  useSeo({
    title: "I.META 소개 — 하드웨어부터 웹까지 한 팀에서 처리하는 제품화 파트너 | I.META",
    description:
      "회로 설계, PCB 설계, MCU 펌웨어, 리눅스 디바이스 드라이버, 3D 모델링·프린팅, 서버·웹·앱, AI 활용 개발. 하드웨어부터 웹까지 한 팀에서 처리하는 제품화 파트너 I.META. 광주 — 대면 미팅 가능.",
    path: "/about",
  });

  return (
    <>
      <PageHero kicker={`ABOUT · ${POSITIONING.titleEn}`} title={ABOUT.title} desc={POSITIONING.lines[0]}>
        <p className="page-hero__quote">{MESSAGES.support.oneTeam}</p>
      </PageHero>

      <section className="section section--tight">
        <div className="about">
          <div className="about__col">
            <h2 className="about__sub">기술 범위</h2>
            <ul className="tech-grid">
              {ABOUT.tech.map((t) => {
                const I = Icon[t.icon];
                return (
                  <li key={t.label} className="tech-grid__item">
                    <span className="tech-grid__icon">
                      {I ? <I width="18" height="18" aria-hidden="true" focusable="false" /> : null}
                    </span>
                    {t.label}
                  </li>
                );
              })}
            </ul>

            <h2 className="about__sub">I.META가 하는 일</h2>
            <FlowLine items={CAPABILITY_FLOW} />
            <p className="flowline__note flowline__note--sm">{CAPABILITY_NOTE}</p>

            <h2 className="about__sub">위치</h2>
            <p className="about__lead">{ABOUT.location}</p>
          </div>

          <aside className="about__meta">
            <h2 className="about__meta-title">사업자 정보</h2>
            <div className="about__meta-row"><span>상호</span><strong>{COMPANY.name} · {COMPANY.nameKo}</strong></div>
            <div className="about__meta-row"><span>대표</span><strong>{COMPANY.ceo}</strong></div>
            <div className="about__meta-row"><span>사업자등록번호</span><strong>{COMPANY.bizNo}</strong></div>
            <div className="about__meta-row"><span>본사</span><strong>{COMPANY.address}</strong></div>
            <div className="about__meta-row"><span>연구소</span><strong>{COMPANY.labAddress}</strong></div>
            <div className="about__meta-row"><span>업태</span><strong>{COMPANY.bizCondition}</strong></div>
            <div className="about__meta-row"><span>종목</span><strong>{COMPANY.bizItem}</strong></div>
            <div className="about__meta-row">
              <span>이메일</span>
              <a className="contact__value" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
            </div>
            <div className="about__meta-row">
              <span>전화</span>
              <a className="contact__value" href={`tel:${COMPANY.phone.replace(/-/g, "")}`}>{COMPANY.phone}</a>
            </div>
          </aside>
        </div>
      </section>

      <section className="section">
        <SectionHead kicker="EQUIPMENT" title="보유 장비" />
        <div className="equip">
          {ABOUT.equipment.map((e) => (
            <article key={e.label} className="equip__item">
              <EquipPhoto src={e.photo} alt={e.label} />
              <h3 className="equip__title">{e.label}</h3>
            </article>
          ))}
        </div>
        <p className="note-line">{COMPANY.name} — {COMPANY.tagline}</p>
      </section>

      <CtaBand />
    </>
  );
}
